import { useState } from "react"
import { useTranslation } from "react-i18next"

import { useLayoutContext } from "@/App/useLayoutContext"
import { Line } from "@/components/Line"
import { useIsDesktop } from "@/utils/useIsDesktop"

import { AdaptiveLogoLink } from "./DefaultAdaptiveLogo"
import { InstrumentDropdown } from "./InstrumentDropdown"
import { LanguageSwitcher, useLanguageSync } from "./language-switcher"
import { LoginControls } from "./LoginControls"
import { PWABanner, PWAInstallBanner, PWALaunchButton } from "./PWA"
import { SymbolLogo } from "./SymbolLogo"
import { ThemeSwitcher } from "./theme-switcher"

const SESSION = "PWABanner"

export const Header = () => {
  const { t } = useTranslation()
  const isDesktop = useIsDesktop()
  const [banner, setBanner] = useState<PWABanner>(
    (sessionStorage.getItem(SESSION) as PWABanner) || PWABanner.NotSet,
  )
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const { headerExtra } = useLayoutContext()
  useLanguageSync()

  const updateBanner = (value: PWABanner) => {
    setBanner(value)
    sessionStorage.setItem(SESSION, value)
  }

  return (
    <div
      className="relative"
      role="banner"
      aria-label={t("reactiveTrader.header")}
    >
      <div className="relative flex h-14 max-w-full items-center bg-primary px-lg">
        {isDesktop ? AdaptiveLogoLink : <SymbolLogo />}
        <Line height="4xl" />
        <div
          className={`flex flex-1 items-center justify-end ${isDesktop ? "pl-xl" : "pl-md"}`}
        >
          <InstrumentDropdown />
          {headerExtra}
          <ThemeSwitcher />
          {isDesktop && <LanguageSwitcher />}
          <LoginControls />
          <PWALaunchButton state={banner} setIsModalOpen={setIsModalOpen} />
        </div>
      </div>
      <PWAInstallBanner
        banner={banner}
        updateBanner={updateBanner}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  )
}
